import { FunctionComponent } from 'react';

import { DynamicPdfComponentName, DynamicPdfComponentProps } from '@breathelife/types';

import { Questionnaire } from '../../QuestionnaireVariants/QuestionnaireVariantsA/Questionnaire';
import { AdvisorInformation } from './AdvisorInformation';
import { AnnuitantInformation } from './AnnuitantInformation';
import { CarrierInformation } from './CarrierInformation';
import { ComprehensivePricing } from './ComprehensivePricing';
import { CryptoSignature } from './CryptoSignature';
import { ESignatureContainer } from './ESignatureContainer';
import { InsuranceFirmInformation } from './InsuranceFirmInformation';
import { MedicalInterviewAnswers } from './MedicalInterviewAnswers';
import { OwnerInformation } from './OwnerInformation';
import { PayorInformation } from './PayorInformation';
import { PdfTitle } from './PdfTitle';
import { ProductInformation } from './ProductInformation';
import { ProposedInsuredInformation } from './ProposedInsuredInformation';
import { SubmissionDate } from './SubmissionDate';

const ComponentListA: { [key in DynamicPdfComponentName]: FunctionComponent<DynamicPdfComponentProps> } = {
  ProductInformation: ProductInformation,
  ProposedInsuredInformation: ProposedInsuredInformation,
  OwnerInformation: OwnerInformation,
  PayorInformation: PayorInformation,
  AdvisorInformation: AdvisorInformation,
  AnnuitantInformation: AnnuitantInformation,
  InsuranceFirmInformation: InsuranceFirmInformation,
  PdfTitle: PdfTitle,
  SubmissionDate: SubmissionDate,
  CryptoSignature: CryptoSignature,
  Questionnaire: Questionnaire,
  ESignatureContainer: ESignatureContainer,
  CarrierInformation: CarrierInformation,
  ComprehensivePricing: ComprehensivePricing,
  MedicalInterviewAnswers: MedicalInterviewAnswers,
};

export default ComponentListA;
